import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { Dropdown, Menu } from 'antd';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import ActionMenuProps from './ActionMenuProps.interface';
import { Action, ActionDivider } from '../../..';
import './action-menu.scss';

const ActionMenu = ({
  actions,
  actionText,
  trigger = 'click',
  placement = 'bottomLeft',
  disabled = false,
}: ActionMenuProps): JSX.Element => {
  // Render Menu Item
  const renderMenu = (action: Action): JSX.Element => {
    Logging.Debug('Action Menu:', action);

    return (
      <Menu.Item key={action.key} disabled={action.disabled} onClick={(event) => action.onClick(action.key, action.row)}>
        {action.name}
      </Menu.Item>
    );
  };

  // Render Menu Divider
  const renderDivider = (action: ActionDivider): JSX.Element => <Menu.Divider key={action.key} />;

  const renderMenus = (): JSX.Element => {
    Logging.Debug('Action Menus:', actions);
    const actionList = actions;

    return (
      <Menu className="actionMenu">
        {actionList.map((action: Action | ActionDivider) => (action instanceof ActionDivider ? renderDivider(action) : renderMenu(action)))}
      </Menu>
    );
  };

  const renderMenuLink = (): JSX.Element => {
    Logging.Debug('Action Menu Link');

    return (
      actionText
        ? (
          <div className="actionMenuLink">
            <VtxButton
              id="actionButton"
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onClick={(event: any) => event.preventDefault()}
              type="link"
            >
              {actionText}
            </VtxButton>
          </div>
        )
        : (
          <div className="actionMenuLink">
            <VtxButton
              id="actionButton"
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onClick={(event: any) => event.preventDefault()}
              icon={<VtxIcon type="ellipsis" fontSize={26} />}
              type="link"
            />
          </div>
        )
    );
  };

  React.useEffect(() => {
    // This Code will run once after the initial Render
    Logging.Debug('Action Menu: Mount');

    return (): void => {
      // This Code will run once the component unmounts.
      Logging.Debug('Action Menu: Unmount');
    };
  }, []);

  return (
    <Dropdown
      overlay={renderMenus()}
      trigger={[trigger]}
      placement={placement}
      disabled={disabled}
    >
      {renderMenuLink()}
    </Dropdown>
  );
};

export default ActionMenu;
